import { useState } from 'react';
import { FormInputProps } from '@/@types/form.types';
import ETextInput from '@/components/everridge/ETextInput';
import HideIcon from '@/components/icons/HideIcon';
import ShowIcon from '../icons/ShowIcon';

type Props<T extends {}> = {
	label?: string;
	placeholder?: string;
} & FormInputProps<T>;

const EPasswordInput = <T extends {}>(props: Props<T>) => {
	const [showPassword, setShowPassword] = useState(false);

	const handleShowPassword = () => {
		setShowPassword((prev) => !prev);
	};

	return (
		<div className='relative'>
			<ETextInput
				type={showPassword ? 'text' : 'password'}
				{...props}
			/>
			<div
				className='absolute right-3 inset-y-10 cursor-pointer'
				onClick={handleShowPassword}>
				{showPassword ? <ShowIcon /> : <HideIcon />}
			</div>
		</div>
	);
};

export default EPasswordInput;
